// UserLocation.tsx
import React, { useEffect, useState } from 'react';
import { useMap, Circle } from 'react-leaflet';

// Tipo para las coordenadas del usuario
interface Coordinates {
  lat: number;
  lng: number;
}

const UserLocation: React.FC = () => {
  const [position, setPosition] = useState<Coordinates | null>(null);
  const map = useMap();

  useEffect(() => {
    // Función de éxito para la geolocalización
    const handleSuccess = (pos: GeolocationPosition) => {
      const { latitude, longitude } = pos.coords;
      if(latitude && longitude) setPosition({ lat: latitude, lng: longitude });
    };

    // Función de error para la geolocalización
    const handleError = (error: GeolocationPositionError) => {
      console.error('Error obteniendo la ubicación:', error);
    };

    // Solicitar la ubicación del usuario
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(handleSuccess, handleError, {
        enableHighAccuracy: true,
        maximumAge: 10000,
        timeout: 20000,
      });
    } else {
      console.error('La geolocalización no es compatible con este navegador.');
    }
  }, [map]);

  // Si la posición no está disponible, no renderizar nada
  if (!position) return null;

  return (
    <>
      {/* Círculo que muestra la ubicación actual */}
      <Circle
        center={[position?.lat, position.lng]}
        radius={15} // Radio del círculo en metros
        pathOptions={{ color: 'transparent', fillColor: '#22A867', fillOpacity: 0.2 }}
      />
      <Circle
        center={[position?.lat, position.lng]}
        radius={7} // Radio del círculo en metros
        pathOptions={{ color: '#22A867', fillColor: '#22A867', fillOpacity: 1 }}
      />
      <Circle
        center={[position?.lat, position.lng]}
        radius={2} // Radio del círculo en metros
        pathOptions={{ color: 'white', fillColor: 'white', fillOpacity: 1 }}
      />
    </>
  );
};

export default UserLocation;
